import { buildTimeBrand } from 'config'
import { EnumBrand } from 'config/types'
import { IconBlank, IconCA, IconLCL } from '../icons'

interface Props {
  className?: string
}

export const IconInternalAccount: React.FC<Props> = ({ className }) => {
  switch (buildTimeBrand) {
    case EnumBrand.BLANK: {
      return <IconBlank className={className} />
    }
    case EnumBrand.CA: {
      return <IconCA className={className} />
    }
    case EnumBrand.LCL: {
      return <IconLCL className={className} />
    }
  }
}
